import { useState, useCallback } from 'react';
import type { DragStartEvent, DragEndEvent } from '@dnd-kit/core';
import type { Payment } from '../types';

export function usePaymentDrag(onDrop: (p: Payment) => void) {
  const [active, setActive] = useState<Payment | null>(null);
  const onStart = useCallback((e: DragStartEvent) => {
    setActive((e.active.data.current as { payment: Payment }).payment);
  }, []);
  const onEnd = useCallback(
    (e: DragEndEvent) => {
      const d = active;
      setActive(null);
      if (!e.over || !d) return;
      if (e.over.id === 'paid' && d.status === 'pending') onDrop(d);
    },
    [active, onDrop]
  );
  return { active, onStart, onEnd, onCancel: () => setActive(null) };
}
